<template>
  <Table
    :columns="columns"
    :data="data"
    :loading="loading"
    :border="border"
    :stripe="stripe"
    :size="size"
    :no-data-text="noDataText"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- 透传具名 slot(表头自定义/列 slot 等) -->
    <template v-for="(_, name) in $scopedSlots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
  </Table>
</template>

<script>
// 统一数据表基础组件:包装 iView Table,收敛各页 <Table> 的默认属性(边框/空态文案/尺寸)
// 标准数据网格统一用 <data-table>,列渲染仍走 columns 的 render(与 iView 一致)。
export default {
  name: 'DataTable',
  inheritAttrs: false,
  props: {
    columns: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    border: { type: Boolean, default: true },
    stripe: { type: Boolean, default: false },
    size: { type: String, default: 'default' },
    noDataText: { type: String, default: '暂无数据' }
  }
}
</script>
